
app.controller('RegisterAgreementCtrl', function ($scope, $uibModalInstance, agreementNumber, $window, $q, $http) {

    $scope.agreementNumber = agreementNumber;
    $scope.accept = function () {
        $uibModalInstance.close('accept', $scope.agreementNumber);
    };

    $scope.Broker = '';


    var allPromise = $q.all([

     
    ]);

    allPromise.then(function () {

    });


    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel', $scope.agreementNumber);
    };
});